import { render, staticRenderFns } from "./advertiser-switcher.vue?vue&type=template&id=701a15c0"
import script from "./advertiser-switcher.vue?vue&type=script&lang=js"
export * from "./advertiser-switcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports